import api from "./api";
import { endpoints } from "./endpoints";

export async function createWalletCard({ userId, deviceType }) {
  const { data } = await api.post(endpoints.walletCards.create, {
    userId,
    deviceType,
  });
  return data?.data ?? data;
}

export async function downloadWalletCard({ userId, deviceType }) {
  const { data } = await api.post(endpoints.walletCards.download, {
    userId,
    deviceType,
  });
  return data?.data ?? data;
}

export async function confirmWalletCardInstall({
  walletCardId,
  walletPassId,
  installedAt,
}) {
  const { data } = await api.post(endpoints.walletCards.confirmInstall, {
    walletCardId,
    walletPassId,
    installedAt,
  });
  return data?.data ?? data;
}
